'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = bemReactCore;

var _inherit = require('inherit');

var _inherit2 = _interopRequireDefault(_inherit);

var _renderTag = require('./renderTag');

var _renderTag2 = _interopRequireDefault(_renderTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bemReactCore(options, BaseComponent, classNameBuilder) {
    var entities = {};
    BaseComponent.prototype.__render = (0, _renderTag2.default)(classNameBuilder);

    function applyEntityDecls() {
        var entity = this;
        var entityCls = entity.cls;

        if (entity.decls) {
            entity.decls.forEach(function (_ref) {
                var fields = _ref.fields,
                    staticFields = _ref.staticFields;

                var base = entityCls ? entityCls : entity.base ? entity.base : BaseComponent,
                    propTypes = {},
                    defaultProps = {};

                [].concat(base, staticFields).forEach(function (cls) {
                    if (cls) {
                        cls.propTypes && _extends(propTypes, cls.propTypes);
                        cls.defaultProps && _extends(defaultProps, cls.defaultProps);
                    }
                });

                staticFields = _extends({}, staticFields, { propTypes: propTypes, defaultProps: defaultProps });

                entityCls ? _inherit2.default.self(base, fields, staticFields) : entityCls = entity.cls = (0, _inherit2.default)(base, fields, _extends({
                    displayName: classNameBuilder.stringify(fields.block, fields.elem)
                }, staticFields));
            });

            entity.decls = null;
        }

        if (entityCls && entity.modDecls) {
            var ptp = entityCls.prototype,
                propTypes = _extends({}, entityCls.propTypes),
                defaultProps = _extends({}, entityCls.defaultProps);

            entity.modDecls.forEach(function (_ref2) {
                var predicate = _ref2.predicate,
                    fields = _ref2.fields,
                    staticFields = _ref2.staticFields;

                var predicateFn = buildModPredicateFunction(predicate),
                    autoModsFn = buildAutoModsFunction(predicate);

                autoModsFn && _inherit2.default.self(entityCls, { mods: wrapFieldForMod(autoModsFn, predicateFn, ptp.mods) });

                for (var name in fields) {
                    var field = fields[name];
                    typeof field === 'function' && (fields[name] = wrapFieldForMod(field, predicateFn, ptp[name]));
                }

                if (staticFields) {
                    staticFields.propTypes && _extends(propTypes, staticFields.propTypes);
                    staticFields.defaultProps && _extends(defaultProps, staticFields.defaultProps);
                }

                _inherit2.default.self(entityCls, fields, staticFields);
            });

            _extends(entityCls, { propTypes: propTypes, defaultProps: defaultProps });

            entity.modDecls = null;
        }

        if (entityCls && entity.declWrappers) {
            entity.wrappedCls = entity.declWrappers.reduce(function (prevCls, wrapper) {
                return wrapper(prevCls);
            }, entityCls);
            entity.declWrappers = null;
        }

        return entity.wrappedCls || entityCls;
    }

    function getEntity(key) {
        return entities[key] || (entities[key] = {
            cls: null,
            base: null,
            decls: null,
            modDecls: null,
            applyDecls: applyEntityDecls
        });
    }

    return {
        decl: function decl(base, fields, staticFields, wrapper) {
            if (typeof base !== 'function' && !Array.isArray(base)) {
                wrapper = staticFields;
                staticFields = fields;
                fields = base;
                base = undefined;
            }

            if (typeof staticFields === 'function') {
                wrapper = staticFields;
                staticFields = undefined;
            }

            fixHooks(wrapBemFields(fields));

            var key = classNameBuilder.stringify(fields.block, fields.elem),
                entity = getEntity(key);

            if (base) {
                if (entity.base) throw new Error('BEM-entity "' + key + '" has multiple ancestors');
                entity.base = base;
            }

            entity.decls = entity.decls || [];
            entity.decls.push({ fields: fields, staticFields: staticFields });

            wrapper && (entity.declWrappers || (entity.declWrappers = [])).push(wrapper);

            return entity;
        },
        declMod: function declMod(predicate, fields, staticFields) {
            fixHooks(wrapBemFields(fields));

            var entity = getEntity(classNameBuilder.stringify(fields.block, fields.elem));

            entity.modDecls = entity.modDecls || [];
            entity.modDecls.push({ predicate: predicate, fields: fields, staticFields: staticFields });

            return entity;
        }
    };
}

function wrapWithFunction(obj, name) {
    if (Array.isArray(name)) {
        name.forEach(function (n) {
            return wrapWithFunction(obj, n);
        });
    } else {
        if (obj.hasOwnProperty(name)) {
            var val = obj[name];
            typeof val !== 'function' && (obj[name] = function () {
                return val;
            });
        }
    }

    return obj;
}

function wrapBemFields(obj) {
    return wrapWithFunction(obj, ['tag', 'attrs', 'content', 'mods', 'mix', 'cls']);
}

function buildModPredicateFunction(predicate) {
    if (typeof predicate === 'function') return predicate;

    var modNames = Object.keys(predicate);

    if (modNames.length === 1) {
        // simplest, but most common case
        var modName = modNames[0];

        var modVal = predicate[modName];

        return typeof modVal === 'function' ? modVal : (modVal = castModVal(modVal)) === '*' ? function (props) {
            return !!castModVal(props[modName]);
        } : function (props) {
            return props[modName] === modVal;
        };
    }

    return function (props) {
        var _this = this;

        return modNames.every(function (modName) {
            var modPredicate = predicate[modName];
            return typeof modPredicate === 'function' ? modPredicate.call(_this, props) : modPredicate === '*' ? !!castModVal(props[modName]) : castModVal(modPredicate) === castModVal(props[modName]);
        });
    };
}

function buildAutoModsFunction(predicate) {
    if (typeof predicate === 'function') return undefined;

    var modNames = Object.keys(predicate);

    if (modNames.length === 1) {
        // simplest, but most common case
        var modName = modNames[0];

        return function (props) {
            var _extends2;

            return _extends({}, this.__base.apply(this, arguments), (_extends2 = {}, _extends2[modName] = props[modName], _extends2));
        };
    }

    return function (props) {
        return _extends({}, this.__base.apply(this, arguments), modNames.reduce(function (res, modName) {
            res[modName] = props[modName];
            return res;
        }, {}));
    };
}

function wrapFieldForMod(field, predicateFn, baseMethod) {
    return function () {
        var method = void 0;
        if (predicateFn.call(this, this.props)) {
            method = field;
        } else {
            baseMethod && baseMethod !== field && (method = this.__base);
        }

        return method && method.apply(this, arguments);
    };
}

function castModVal(modVal) {
    return typeof modVal === 'number' ? modVal.toString() : modVal;
}

var lifecycleHooks = {
    willMount: 'componentWillMount',
    didMount: 'componentDidMount',
    willReceiveProps: 'componentWillReceiveProps',
    shouldUpdate: 'shouldComponentUpdate',
    willUpdate: 'componentWillUpdate',
    didUpdate: 'componentDidUpdate',
    willUnmount: 'componentWillUnmount'
};

function fixHooks(obj) {
    for (var oldName in lifecycleHooks) {
        if (obj[oldName]) {
            obj[lifecycleHooks[oldName]] = obj[oldName];
            delete obj[oldName];
        }
    }return obj;
}